/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     远程监控状态管理
  +--------------------------------------------------------------------------------------
*/

import Vue from "vue";

const rmsStore = {
  state: {
    equipStaticArr: [],
    equipEventTypeArr: [
      { value: 0, title: "全部", separate: true },
      { value: 1, title: "开机", style: "text-success" },
      { value: 2, title: "关机", style: "text-blue" },
      { value: 3, title: "告警", style: "text-danger" },
      { value: 4, title: "告警解除", style: "text-info" },
      { value: 5, title: "上线", style: "text-blue" },
      { value: 6, title: "掉线", style: "text-warning" }
    ],
    userEventTypeArr: [
      { value: 1, title: "开机", style: "text-success" },
      { value: 2, title: "关机", style: "text-blue" },
      { value: 7, title: "查看", style: "text-info" },
      { value: 8, title: "设置", style: "text-warning" }
    ],
    authArr: [
      { value: 1, title: "用户", style: "text-info" },
      { value: 2, title: "用户管理员", style: "text-warning" },
      { value: 3, title: "工程商", style: "text-warning" },
      { value: 4, title: "经销商", style: "text-success" },
      { value: 5, title: "厂商", style: "text-success" },
      { value: 10, title: "鱼漾", style: "text-success" }
    ]
  },

  mutations: {
    SET_EQUIP_STATIC: (state, equips) => {
      Vue.set(state, "equipStaticArr", equips);
    }
  },

  actions: {}
};

export default rmsStore;
